<template>
  <div class="ui form" ref="form">
    <div v-if="branch_based.movements">
      <h4 class="ui dividing header">{{ $t("movements to charge") }}</h4>
      <div class="ui relaxed list">
        <div
          class="item"
          v-for="(mv, idx) in branch_based.movements"
          :key="idx"
        >
          <i class="large green check middle aligned icon"></i>
          <div class="content">
            <div class="ui grid">
              <div class="row" style="padding-bottom: 7px">
                <div class="two wide column">
                  <div class="field">
                    <label for v-if="idx == 0">{{ $t("quantity") }}</label>
                    <input
                      type="text"
                      v-model="branch_based.movements[idx].quantity"
                    />
                  </div>
                </div>
                <div class="six wide column">
                  <div class="field">
                    <label for v-if="idx == 0">{{ $t("movement type") }}</label>
                    <h4
                      class="ui movement name header"
                      :data-idx="idx"
                      style="margin-top: 10px"
                    >
                      {{ mv.movement.name }}
                    </h4>
                  </div>
                </div>
                <div class="two wide column">
                  <div class="field">
                    <label for v-if="idx == 0">{{ $t("amount") }}</label>
                    <input
                      type="text"
                      v-model="branch_based.movements[idx].amount"
                    />
                  </div>
                </div>
                <div class="four wide column" v-if="mv.expire_date">
                  <div class="field">
                    <label for v-if="idx == 0">{{ $t("expire date") }}</label>
                    <div
                      class="ui expire date calendar"
                      ref="expire_calendar"
                      :data-i="idx"
                    >
                      <div class="ui input left icon">
                        <i class="calendar icon"></i>
                        <input
                          type="text"
                          :placeholder="$t('expire date')"
                          v-model="branch_based.movements[idx].expire_date"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="two wide column">
                  <div class="field">
                    <label for v-if="idx == 0">{{ $t("options") }}</label>
                    <div
                      class="ui basic icon button"
                      :data-tooltip="$t('delete')"
                      @click="remove_mv(mv, idx)"
                    >
                      <i class="red trash icon"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty } from "lodash";
// import ReceiptModal from "@/modules/student_inscription/receipt_modal/ReceiptModal";

export default {
  name: "InscriptionModalBranchBased",
  components: {},
  props: {
    branch_based: Object,
    inscription_configuration: Object,
  },
  computed: {},
  data() {
    return {};
  },
  methods: {
    remove_mv(movement, index) {
      if (
        this.branch_based &&
        this.branch_based.movements &&
        this.branch_based.movements.length
      )
        this.branch_based.movements.splice(index, 1);
    },

    runScript(tryNumber) {
      console.log("running script attempt", tryNumber);
      if (tryNumber <= 10) {
        let vm = this;
        if (
          this.inscription_configuration &&
          !isEmpty(this.inscription_configuration)
        ) {
          if (
            this.inscription_configuration.run_script &&
            vm.inscription_configuration.script
          ) {
            try {
              // eslint-disable-next-line no-unused-vars
              eval(vm.inscription_configuration.script);
            } catch (error) {
              console.error(error);
            }
          }
        } else {
          setTimeout(() => {
            vm.runScript(tryNumber + 1);
          }, 500);
        }
      } else {
        console.log("try limit reached");
      }
    },
  },
  created() {},
  mounted() {
    window.jQuery(this.$refs.form).form({
      fields: {
        student: ["empty"],
        period: ["empty"],
        branch: ["empty"],
        career: ["empty"],
      },
    });

    setTimeout(() => {
      window.jQuery(this.$refs.expire_calendar).calendar({
        type: "date",
        onChange(/* value */) {
          // console.log(this, value);
        },
      });
    }, 2000);

    // this.runScript(1);
  },
  watch: {},
};
</script>
